import React, { useState } from "react";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Status, useApi } from "../../services/useApi/useApi";
import { ROUTER_PATHS } from "../../constants/constants";

/** CallbackHandler handles the callback with the server. It will render the child with
 *  the needed data. */
export const CallbackHandler = ({ callbackURL, callbackInfo, formatData }) => {
  const { call, data, status, error } = useApi(callbackURL);
  const [authData, setAuthData] = useState(null)

  useEffect(() => {
    call({ params: callbackInfo });
  }, [call, callbackInfo]);

  useEffect(() => {
    if (error || status !== Status.Done) return
    if (data) {
      setAuthData(formatData(data))
    }
  }, [data, error, formatData, status])

  if (status === Status.Error) return <Navigate to={`/${ROUTER_PATHS.UNAUTHORISED_USER}`} replace />;
  if (authData) return <Navigate to="/" replace state={{ oauthData: authData }} />;
};
